import React from "react";
import "./GuidedTour.scss";

interface IGuidedTour {
  title: string;
  content: string;
}

const GuidedTour: React.FC<IGuidedTour> = ({ title, content }) => {
  return (
    <div className="GuidedTour">
      <div className="title">{title}</div>
      <div className="content">{content}</div>
    </div>
  );
};

export default GuidedTour;
